import React, {FC} from "react";
import {IconButton, Typography} from "@material-ui/core";
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  OpenInNew as OpenInNewIcon,
} from "@material-ui/icons";

interface AmendmentsHeaderProps {
  explanation: string;
  explanationMeta?: string;
  currentIndex?: number;
  totalAmendments?: number;
  onNavigate?: (direction: number) => void;
  onOpenConversation?: () => void;
  isConversationActive?: boolean;
  titlePrefix?: React.ReactNode;
  titleSuffix?: React.ReactNode;
}

const headerStyles = {
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  navigation: {
    display: "flex",
    alignItems: "center",
  },
  pageCount: {
    fontWeight: 500,
    margin: "10px",
  },
  explanation: {
    color: "#444",
    marginBottom: "4px",
    fontSize: "0.9rem",
  },
  meta: {
    color: "#999",
    fontSize: "0.75rem",
    marginBottom: "8px",
  },
  metaRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "8px",
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: "4px",
  },
};

const AmendmentsHeader: FC<AmendmentsHeaderProps> = ({
  explanation,
  explanationMeta,
  currentIndex,
  totalAmendments,
  onNavigate,
  onOpenConversation,
  isConversationActive,
  titlePrefix,
  titleSuffix,
}) => (
  <>
    <div style={headerStyles.header}>
      {onNavigate &&
        currentIndex !== undefined &&
        totalAmendments !== undefined && (
          <div style={headerStyles.navigation}>
            <IconButton
              onClick={() => onNavigate(-1)}
              size="small"
              aria-label="Previous amendment"
            >
              <ChevronLeftIcon />
            </IconButton>
            <div style={headerStyles.pageCount}>
              {currentIndex + 1}/{totalAmendments}
            </div>
            <IconButton
              onClick={() => onNavigate(1)}
              size="small"
              aria-label="Next amendment"
            >
              <ChevronRightIcon />
            </IconButton>
          </div>
        )}
    </div>
    <div style={headerStyles.titleRow}>
      {titlePrefix}
      <Typography
        style={{...headerStyles.explanation, flex: 1, marginBottom: 0}}
      >
        {explanation}
      </Typography>
      {titleSuffix}
    </div>
    {explanationMeta && (
      <div style={headerStyles.metaRow}>
        <Typography style={{...headerStyles.meta, marginBottom: 0}}>
          {explanationMeta}
        </Typography>
        {onOpenConversation && (
          <IconButton
            size="small"
            onClick={onOpenConversation}
            aria-label="Open conversation"
            style={{padding: "2px"}}
            disabled={isConversationActive}
          >
            <OpenInNewIcon
              style={{
                width: "18px",
                height: "18px",
                color: isConversationActive ? "#ccc" : "#1976d2",
              }}
            />
          </IconButton>
        )}
      </div>
    )}
  </>
);

export default AmendmentsHeader;
